// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"CobraQeSummary_sectionHeader__2A2cW","link":"CobraQeSummary_link__3tuTV"};